/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-max-props-per-line */
/**
 * @name NoticesSidebar
 * @description Componente drawer de noticias para el home de Talentry
 * @author Alexis Becerra
 */

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import styled from 'styled-components';
import moment from 'moment';
import CountUp from 'react-countup';

import { Lines, InfoNumber } from '@components';
import { Flex, Icons, MUI, Theme, Typography } from '@styles';

// Material-UI
import MuiDrawer from '@material-ui/core/Drawer';

const NoticesSideBar = ({ open, notices, toggleHandler }) => {
  const [expandedIndexes, setExpandedIndexes] = useState([]);

  // Use effect to set the first event as expanded when the component mounts
  useEffect(() => {
    if (Object.keys(notices).length > 0) {
      setExpandedIndexes([0]); // Expand the first event by default
    }
  }, [notices]);

  return (
    <Styled.Drawer
      open={open}
      anchor={'right'}
      onClose={toggleHandler}
    >
      <MUI.Box display="flex" width="100%" height="100%">
        <Lines
          direction="vertical"
          firstLine={{ size: 50, color: 'purple' }}
          secondLine={{ size: 50, color: 'blueDark' }}
        />
        <Styled.FlexContent padding="16px">
          <Styled.ButtonIcon onClick={toggleHandler}>
            <Icons.Close />
          </Styled.ButtonIcon>
          {/* Noticias */}
          {Object.keys(notices).map((key, index, array) => (
            <div key={index}>
              {expandedIndexes.includes(index) && (
                <Styled.Details>
                  <Flex.Row alignItems="center" justifyContent="center" padding="8px 8px 0">
                    <Typography.Medium color="blueMedium" style={{ fontVariant: 'small-caps' }}>{'Reconocimientos'}</Typography.Medium>
                  </Flex.Row>
                  {/* Imagen */}
                  <Styled.ImageBox>
                    <Styled.CardImage>
                      <Styled.CompanyLogoImg url="https://assets.talentry.io/icons/appicons/talents.png" />
                    </Styled.CardImage>
                  </Styled.ImageBox>
                  {/* RECONOCIMIENTOS */}
                  {key === 'Reconocimientos' && (
                    <>
                      <Flex.Col padding="8px">
                        <Typography.Text color="greyDarkAlpha">{`${i18n.t('GenericMessages.nextDelivery')}:`}</Typography.Text>
                        <Typography.H6>{notices[key].NombreEntrega}</Typography.H6>
                      </Flex.Col>

                      <Flex.Col justifyContent="space-between">
                        <Flex.Row padding="8px">
                          <Styled.IconBox>
                            {/* <Icons.CalendarX size="20" color={Theme.colors.greyDark} /> */}
                            <CalendarX size="20" color={Theme.colors.greyDark} secondColor={Theme.colors.red} />
                          </Styled.IconBox>
                          <Flex.Col>
                            <Typography.Medium>{`${i18n.t('GenericMessages.dueDate')}: `}</Typography.Medium>
                            <Typography.Text color="greyDarkAlpha">
                              {`${moment(notices[key].FechaVencimiento).format('dddd.')} `}
                              <Typography.Span>{moment(notices[key].FechaVencimiento).format('DD MMM. YYYY')}</Typography.Span>
                            </Typography.Text>
                          </Flex.Col>
                        </Flex.Row>
                        <Flex.Row padding="8px">
                          <Styled.IconBox>
                            {/* <Icons.CalendarShare size="20" color={Theme.colors.greyDark} /> */}
                            <CalendarShare size="20" color={Theme.colors.greyDark} secondColor={Theme.colors.blueMedium} />
                          </Styled.IconBox>
                          <Flex.Col>
                            <Typography.Medium>{`${i18n.t('GenericMessages.nextDeliveryDate')}: `}</Typography.Medium>
                            <Typography.Text color="greyDarkAlpha">
                              {`${moment(notices[key].ProximaFechaEntrega).format('dddd.')} `}
                              <Typography.Span>{moment(notices[key].ProximaFechaEntrega).format('DD MMM. YYYY')}</Typography.Span>
                            </Typography.Text>
                          </Flex.Col>
                        </Flex.Row>
                      </Flex.Col>

                      <MUI.Divider margin="16px 8px" />

                      <Flex.Row justifyContent="space-between">
                        <Flex.Col padding="8px">
                          <Typography.Medium>
                            {`${i18n.t('GenericMessages.earringsToRecognize')}: `}
                          </Typography.Medium>
                          <Flex.Row padding="8px">
                            <Styled.AckNumber>
                              <CountUp end={notices[key].ArosFaltantesRegalar} delay={1} />
                            </Styled.AckNumber>
                          </Flex.Row>
                          {/* <InfoNumber
                            color="blueDark"
                            title={
                              <Flex.Col style={{ marginBottom: '8px' }}>
                              <Typography.Text color="greyDarkAlpha">{i18n.t('GenericMessages.pending')}</Typography.Text> 
                                <Typography.Medium>{`${i18n.t('GenericMessages.earringsToRecognize')}:`}</Typography.Medium>
                              </Flex.Col>
                            }
                            number={notices[key].ArosFaltantesRegalar}
                            iconComponent={<Icons.ExportCircle size="55" color={Theme.colors.blueDarkAlpha} />}
                          /> */}
                        </Flex.Col>
                        <Flex.Col padding="8px">
                          <Typography.Medium>
                            {`${i18n.t('GenericMessages.pendingToRedeem')}: `}
                          </Typography.Medium>
                          <Flex.Row padding="8px">
                            <Styled.AckNumber>
                              <CountUp end={notices[key].ArosFaltantesCanjear} delay={1} />
                            </Styled.AckNumber>
                          </Flex.Row>
                          {/* <InfoNumber
                            color="purple"
                            title={
                              <Flex.Col style={{ marginBottom: '8px' }}>
                                <Typography.Medium>{`${i18n.t('GenericMessages.pendingToRedeem')}: `}</Typography.Medium>
                              </Flex.Col>
                            }
                            number={notices[key].ArosFaltantesCanjear}
                            iconComponent={<Icons.ImportCircle size="55" color={Theme.colors.purpleAlpha} />}
                          /> */}
                        </Flex.Col>
                      </Flex.Row>
                    </>
                  )}
                </Styled.Details>
              )}

              {/* Divider logic */}
              {array.length > 1 && index !== array.length - 1 && (
                <MUI.Divider margin="16px 8px" />
              )}
            </div>
          ))}
        </Styled.FlexContent>
      </MUI.Box>
    </Styled.Drawer>
  );
};

// Icons.CalendarShare
const CalendarShare = ({ size, color, secondColor }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 21h-6a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v6"></path>
    <path d="M16 3v4"></path>
    <path d="M8 3v4"></path>
    <path d="M4 11h16"></path>
    <path d="M16 22l5 -5" stroke={secondColor}></path>
    <path d="M21 21.5v-4.5h-4.5" stroke={secondColor}></path>
  </svg>
);

// Icons.CalendarX
const CalendarX = ({ size, color, secondColor }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" xmlns="http://www.w3.org/2000/svg">
    <path d="M13 21h-7a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v6.5"></path>
    <path d="M16 3v4"></path>
    <path d="M8 3v4"></path>
    <path d="M4 11h16"></path>
    <path d="M22 22l-5 -5" stroke={secondColor}></path>
    <path d="M17 22l5 -5" stroke={secondColor}></path>
  </svg>
);

NoticesSideBar.propTypes = {
  // Boolean que indica si esta abierto el drawer lateral.
  open: PropTypes.bool.isRequired,
  // Objeto con la información de las noticias.
  notices: PropTypes.object.isRequired,
  // Función para desplegar el drawer lateral.
  toggleHandler: PropTypes.func.isRequired,
};

// *************************************
// STYLED COMPONENTS                               
// *************************************

const Styled = {};

Styled.Drawer = styled(MuiDrawer)`
  .MuiDrawer-paperAnchorRight {
    top: 64px;
    min-width: 450px;
    max-width: 450px;
  }
  .MuiBackdrop-root {
    top: 64px;
  }
  &.MuiDrawer-root {
    top: 64px !important;
    width: 250px;
  }
`;

Styled.FlexContent = styled(Flex.Col)`
  width: 100%;
  max-height: calc(100vh - 65px);
  background-color: ${(props) => props.theme.colors.white};
  overflow-y: auto;
  scrollbar-width: thin !important;
`;

Styled.ButtonIcon = styled(MUI.ButtonIcon)`
  position: absolute;
  top: 8px; 
  right: 16px;
  background-color: ${(props) => props.theme.colors.greyLight};
`;

Styled.ImageBox = styled.div`
  width: 100%;
  padding: 8px;
  margin-bottom: 8px;
`;

Styled.IconBox = styled.div`
  width: 20px;
  height: 20px;
  min-width: 20px;
  min-height: 20px;
  margin-right: 8px;
`;

Styled.CardImage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 100px;
  padding: 8px;
  border-radius: 6px;
  // background-color: ${(props) => props.theme.colors.greyHover};
  box-shadow: ${(props) => props.theme.shadows.depth1};
`;

Styled.Details = styled.div`
  background-color: ${(props) => props.theme.colors.white};
  padding: 8px 0;
  // border-radius: 4px;
  // box-shadow: ${(props) => props.theme.shadows.depth1};
`;

Styled.CompanyLogoImg = styled.div`
  width: 100%;
  height: 80px;
  background-image: url(${(props) => props.url});
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  background-color: ${(props) => props.theme.colors.white};
  // border-radius: 6px;
`;

Styled.AckNumber = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center; /* Alinea el contenido al centro horizontalmente */
  flex: 1;
  margin-right: 8px;

  & > span {
    font-family: 'Bryant Pro Medium';
    font-variant: tabular-nums;
    font-size: 25px;
    line-height: 28px;
    color: ${(props) => props.theme.colors.greyDark};  
  }
`;

export default NoticesSideBar;
